export const DEFAULT_DATA_ADJUSTMENT_STATE = {
  ndx: null,
  collect_date: null,
  location_ndx: null,
  measure_type_ndx: null,
  override_value: null,
  notes: null,
};
